import React, { useState, useEffect } from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import { Link, useHistory } from "react-router-dom";

import loginLogo from "../assets/img/logo.png";
import Image from "../assets/img/verified.jpeg";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import useRequest from "../hooks/useRequest";
import { toast } from "react-toastify";

const EmailVerify = () => {
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const { token } = useParams();
  const { response, request } = useRequest();

  const handleVerifyEmail = async () => {
    if (token) {
      setLoading(true);

      request("POST", "verifyRegistration", { managerId: token });
    }
  };

  useEffect(() => {
    if (response) {
      if (response.status == "success") {
        toast.success(response.message);
        history.push("/login");
      }
    }
  }, [response]);

  return (
    <div className="ms-body ms-primary-theme ms-logged-out">
      <main className="body-content">
        <div className="ms-content-wrapper ms-auth">
          <Row>
            <Col md={5}>
              <div className="ms-auth-bg">
                <img src={loginLogo} />
              </div>
            </Col>
            <Col>
              <div className="verify-email">
                <img src={Image} />
                <h2>Thank You!</h2>
                <p>Click to verify your email.</p>

                <button
                  className="btn btn-primary"
                  onClick={handleVerifyEmail}
                  disabled={loading}
                >
                  Verify Email
                </button>
              </div>
            </Col>
          </Row>
        </div>
      </main>
    </div>
  );
};

export default EmailVerify;
